import React from 'react'
import { Modal, Empty, Button, Icon } from 'antd'
import { ImagePreview } from '../../../../../components'
import './PropSelectionModal.scss'

const PropSelectionModal = ({
  visible,
  onCancel,
  onSelect,
  propMap = {},
  propReference = {},
  currentPropKey
}) => {
  const keys = Object.keys(propMap || {})

  const renderPropItem = key => {
    const refs = propReference || {}
    // Handle both wrapped and unwrapped keys
    const refKey = refs[`__${key}__`] ? `__${key}__` : key
    const reference = refs[refKey]
    const imageSrc =
      reference &&
      (reference.uri || reference.url || reference.image || reference.src)

    const isSelected =
      currentPropKey &&
      (currentPropKey === key || currentPropKey === `__${key}__`)

    return (
      <div
        key={key}
        className={`prop-card-item ${isSelected ? 'is-selected' : ''}`}
      >
        {isSelected && (
          <div className="selected-badge">
            <Icon type="check" />
          </div>
        )}

        <div className="prop-image-wrapper">
          {imageSrc ? (
            <ImagePreview
              src={imageSrc}
              alt={key}
              style={{ width: '100%', height: '100%', objectFit: 'cover' }}
            />
          ) : (
            <div className="no-image">
              <Icon type="picture" />
              <span>No Image</span>
            </div>
          )}
        </div>

        <div className="prop-content">
          <div className="prop-header">
            <h4 title={key}>{key}</h4>
            <p title={propMap[key]}>{propMap[key]}</p>
          </div>

          <div className="prop-action">
            {isSelected ? (
              <Button type="dashed" block className="selected-btn">
                <Icon type="check-circle" /> Selected
              </Button>
            ) : (
              <Button type="primary" ghost block onClick={() => onSelect(key)}>
                Select
              </Button>
            )}
          </div>
        </div>
      </div>
    )
  }

  return (
    <Modal
      maskClosable={false}
      title="Select Prop Reference"
      visible={visible}
      onCancel={onCancel}
      footer={null}
      width={1000}
      centered
      wrapClassName="prop-selection-modal"
    >
      {keys.length > 0 ? (
        <div className="prop-grid">{keys.map(renderPropItem)}</div>
      ) : (
        <Empty description="No props available. Add props in the Props setup step." />
      )}
    </Modal>
  )
}

export default PropSelectionModal
